import useLogoutFn from '@/hooks/useLogoutFn.jsx';
import HeaderChip from '@components/HeaderChip.jsx';
import { Box, Button, IconButton, Popover } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconLogout, IconUser, IconX } from '@tabler/icons-react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileInfos from './ProfileInfos.jsx';

// ==============================|| PROFILE MENU ||============================== //
function ProfileSection() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const logoutFn = useLogoutFn();

    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <HeaderChip
                Icon={IconUser}
                tooltip={t('showProfileInfos')}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup='true'
                onClick={handleToggle}
                ref={anchorRef}
            />

            <Popover
                anchorEl={anchorRef.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                elevation={4}
                onClose={handleClose}
                open={open}
                slotProps={{
                    paper: {
                        sx: {
                            p: 0,
                            borderRadius: theme.borders.borderRadius.xl,
                            background: theme.palette.primary.main
                        }
                    }
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <Box
                    sx={{
                        maxHeight: { xs: 'calc(100vh - 28px)', sm: 'calc(100vh - 65px)' },
                        p: 3.5,
                        pb: 2.5,
                        width: { xs: 'calc(100vw - 28px)', sm: '430px' },
                        color: '#fff',
                        overflow: 'auto'
                    }}
                >
                    <IconButton
                        aria-label={t('closeProfile')}
                        onClick={handleClose}
                        size='large'
                        sx={{
                            'outlineOffset': '-4px',
                            'position': 'absolute',
                            'top': '15px',
                            'right': '15px',
                            'zIndex': 5,
                            '& svg': {
                                width: '1.5rem !important',
                                height: '1.5rem !important'
                            }
                        }}
                        title={t('closeProfile')}
                    >
                        <IconX color={theme.palette.secondary.main} />
                    </IconButton>

                    <OverlayScrollbarsComponent
                        defer
                        options={{ scrollbars: { theme: 'os-theme-light' } }}
                    >
                        <ProfileInfos closePopover={() => setOpen(false)} />

                        <Button
                            color='white'
                            fullWidth
                            onClick={logoutFn}
                            startIcon={<IconLogout />}
                            sx={{ my: 2, outlineOffset: '-3px' }}
                            variant='outlined'
                        >
                            {t('logOutSB')}
                        </Button>

                        <Box color='#eee' fontSize='0.8rem' textAlign='center' width='100%'>
                            Version {/* eslint-disable-line */ __APP_VERSION__}
                        </Box>
                    </OverlayScrollbarsComponent>
                </Box>
            </Popover>
        </>
    );
}

export default ProfileSection;
